import { render, staticRenderFns } from "./documentSelectorDialog.vue?vue&type=template&id=2cf6c30d&scoped=true&"
import script from "./documentSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./documentSelectorDialog.vue?vue&type=script&lang=js&"
import style0 from "./documentSelectorDialog.vue?vue&type=style&index=0&id=2cf6c30d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6c30d",
  null
  
)

export default component.exports